<div style="position: absolute;top: 0px;left: 0px;right: 0px;color: #1E3481;font-weight: bold;cursor: pointer;
 background: linear-gradient(orange,  white);height: 65px;text-transform: uppercase;" class="navbar navbar-dark  ">
    <a class="nav-item nav-link" style="color: #1E3481;" routerLink="/">
        <img src="../assets/img/header/client.png" width="40" alt=""> Prospect
    </a>

    <a class="nav-item nav-link" routerLinkActive='active' (click)="  getAll('interne') ">
        <img src="../assets/img/header/client.png" width="40" alt=""> Plan interne
    </a>
    <a class="nav-item nav-link" routerLinkActive='active' (click)="  getAll('code') ">
        <img src="../assets/img/header/client.png" width="40" alt=""> Code couleur
    </a>
    <a class="nav-item nav-link" routerLinkActive='active' (click)="  getAll('materiel') ">
        <img src="../assets/img/header/client.png" width="40" alt=""> Materiel Spécifique
    </a>
    <a class="nav-item nav-link" routerLinkActive='active' (click)="  getAll('type') ">
        <img src="../assets/img/header/client.png" width="40" alt=""> Type de stand
    </a>

    <a class="nav-item nav-link" routerLinkActive='active' (click)="  getAll('gris') ">
        <img src="../assets/img/header/client.png" width="40" alt=""> Plan Gris
    </a>
</div>
<mat-drawer-container class="example-container">
    <mat-drawer mode="side" opened>

        <mat-tab-group>
            <mat-tab label="Stand">
                <div style="width: 300px;padding: 25px;">
                    <label>Rechercher un stand</label>
                    <p-autoComplete [(ngModel)]="selectedStand" appendTo="body" style="width:500px;"
                        [suggestions]="filteredStandsSingle" (onSelect)='selectStand(selectedStand )'
                        (completeMethod)="filterStandSingle($event)" field="num" placeholder="Stands"></p-autoComplete>
                    <br>
                    <br>
                    <label>Rechercher un Exposant</label>
                    <p-autoComplete [(ngModel)]="selectedExhibitor" appendTo="body" style="width:500px;"
                        [suggestions]="filteredExhibitorsSingle" (onSelect)='selectExhibitor(selectedExhibitor)'
                        (completeMethod)="filterExhibitorSingle($event)" field="text1" placeholder="Exhibitors">
                    </p-autoComplete>
                    <br>
                    <br>
                    <div *ngIf="selectedStand">






                        <div style="display: flex;">
                            <span class="ui-float-label">
                                <input id="float-input0" [(ngModel)]="selectedStand.num" pInputText
                                    style="width: 100%;margin: 3px;" />

                                <label for="float-input0">Numéro du stand</label>
                            </span>
                            <span class="ui-float-label">
                                <input id="float-input1" [(ngModel)]="selectedStand.height" pInputText
                                    style="width: 100%;margin: 3px;" />

                                <label for="float-input1">Hauteur</label>
                            </span>


                            <span class="ui-float-label">
                                <input id="float-input2" [(ngModel)]="selectedStand.width" pInputText
                                    style="width: 100%;margin: 3px;" />

                                <label for="float-input2">Largeur</label>
                            </span>
                        </div>



                        <br>
                        <label for="float-input3">Type du stand</label>
                        <br>
                        <p-dropdown appendTo='body' id="float-input3" [ngStyle]="{'width': '100%'}" [options]="types"
                            [(ngModel)]="selectedStand.standType" editable="false" placeholder="Select a Type">
                        </p-dropdown>

                        <br> <br> <br>

                        <div style="display: flex;">
                            <div>
                                <label for="float-input1">Bordures</label> <br>

                                <div style="text-align: center;width: 100px;">





                                    <div style="display: flex;align-items: center;">

                                        <div [ngStyle]="{'border-right':selectedStand.borederlr===1 ? 'orange solid' : 'grey solid thin'  ,
        'border-left': selectedStand.borederl===1 ? 'orange solid' : 'grey solid thin' ,
        'border-top': selectedStand.boredert===1 ? 'orange solid' : 'grey solid thin' ,
        'border-bottom': selectedStand.borederb===1 ? 'orange solid' : 'grey solid thin' ,
        'height': '70px','width': '100px'}">


                                            {{selectedStand.superficie}}m
                                        </div>

                                    </div>



                                </div>
                            </div>

                        </div>


                        <br>

                        <br>


                        <div style="font-weight: bold;margin-top: 10px;">
                            Exposants:
                        </div>
                        {{selectedStand.clientList}}
                        <br><br>

                        <div *ngIf="isAdmin"
                        style="background-image: url('../assets/img/header.png');height: 40px;text-transform: uppercase;"
                        class="navbar navbar-dark  ">
                        <a class="btn " style="color: white;font-weight: bolder;" [href]="urlPlan"
                            routerLinkActive="router-link-active">Editer Plan </a>
                  
                    </div>

                        <br>
                        <br>
                        <label for="inputre"> Remarque</label>

                        <textarea id="inputre" rows="5" cols="15" disabled [(ngModel)]="selectedStand.remarque"
                            pInputTextarea style="width: 100%;"></textarea>



                    </div>

                </div>
            </mat-tab>
            <mat-tab label="Finance">
                Superficie Aménagé: <strong> {{superficieAmenage}} </strong> <br><br>
                Superficie Semi Aménagé: <strong> {{superficieSemiAmenage}} </strong> <br><br>
                Superficie Nu: <strong> {{superficieNuAmenage}} </strong> <br><br>
                Total: <strong> {{superficieAmenage+superficieNuAmenage+superficieSemiAmenage}} </strong> <br><br>


                <div style="padding: 25px;">
                    Total Factures: <strong>{{totalFactures | currency :'.' }} {{devise}} </strong> <br><br>
                    Total Paiement: <strong>{{totalPaiement | currency:'.' }} {{devise}} </strong> <br><br>
                    Total Solde: <strong>{{solde | currency:'.' }} {{devise}} </strong> <br><br>





                    <div [style]="{'background-color': solde==0 ? 'green' :totalPaiement==0 ? 'red' : 'orange' }"
                        style="color: white;font-weight: bolder;height:'50px';width:'50px'">

                    </div>
                </div>


            </mat-tab>

        </mat-tab-group>


    </mat-drawer>
    <mat-drawer-content>


        <div style="height: 85vh;">


            <a [routerLink]="['/edit-floor']" routerLinkActive="router-link-active"> edit fooolr</a>
            <app-compose-mail appendTo='body' style="z-index: 99999999;"></app-compose-mail>

            <button style="margin-left: 3500px;" id="pop" (click)="selectAnimd('B4-08')"> dd</button>


            <div style="width: 500px;height: 50px; margin-left:2200px;">


                <button mat-button style="float: left;" (click)="captureScreenAll()">Export Plan global</button>
                <button mat-button style="float: left;" *ngIf="false" (click)="captureScreen1()">Export Plan
                    externe</button>
                <button mat-button style="float: left;" *ngIf="false" (click)="captureScreen()">Export Plan
                    interne</button>
                <span style="background: #FFFF00;height: 30px;width: 50px;float: left;cursor: crosshair;"
                    (click)="selectColor('#FFFF00')"> </span>
                <span style="background: #FF9300;height: 30px;width: 50px;float: left;cursor: crosshair;"
                    (click)="selectColor('#FF9300')"> </span>

            </div>
            <!--width:2800px;-->
            <div class="plancomplet" style="height: 1500px;width: 3500px; cursor: pointer;
            ">



                <div id="draggable" class="intro " style="height: 1500px;width: 1900px; cursor: pointer;
                position: absolute; 
           left: 1530px;  
           background-color: white!important;  
           background: url('../../../assets/img/47.png');">




                    <div id="dss"  
                        style="height:2259px;width:1900px; float: left; background-image: url('/assets/img/caneva.png');">



                        <div id="{{stand.idStand}}" (click)="onStandClick(stand) " *ngFor="let stand of stands" style="border: red solid;z-index: 999;
 position: absolute;text-align: center;font-size: 11px;cursor: pointer; font-weight: bolder;text-transform: uppercase;"
                            [ngStyle]="{'width': stand.width*10+'px','height': stand.height*10+'px','top': stand.topL +'px'
 ,'left': stand.leftL +'px'
 ,'border-top': '#000  solid 1px'
 ,'border-bottom':  '#000  solid '+stand.borederb+'px'
 ,'border-left':  '#000  solid '+stand.borederl +'px'
 ,'border-right':  '#000  solid '+stand.borederlr+'px'
 ,'background-color': stand.backgroundColor    }">
                            <div>
                                <span *ngIf="stand.standType!='Flag' && stand.standType!='Entrance'"
                                    style="font-weight: bolder;">
                                    {{stand.num}}
                                </span>
                                <span style="color: red;font-size: 8px;"
                                    *ngIf="stand.standType!='Flag' && stand.standType!='Entrance'">
                                    {{stand.height*stand.width| number}}m2 </span>
                                <img *ngIf="stand.standType=='Flag'"
                                    [ngStyle]="{'width': stand.width*10+'px','height': stand.height*10+'px'}"
                                    [src]="'../../../assets/img/'+stand.num+'.png'" />

                                <img *ngIf="stand.standType=='Entrance'"
                                    [ngStyle]="{'width': stand.width*10+'px','height': stand.height*10+'px'}"
                                    [src]="'../../../assets/img/entrance.png'" />

                                <img src="../../../assets/img/localise.gif"
                                    *ngIf="selectedList && selectedList.indexOf(stand.num) == 0" width="20" height="20">
                                <img src="../../../assets/img/localise.gif" *ngIf="selectedStandId==stand.idStand"
                                    width="20" height="20">


                            </div>
                        </div>




                    </div>




                </div>
                <div id="draggableo" class="intro1 " style="height: 1500px;width: 1530px; cursor: pointer;position: absolute;  
         
                background-color: white!important;  
                background: url('../../../assets/img/outside.png');">



                    <div id="dsso" style="height:1300px;width:2000px;float: left; ">


                        <div>
                            <div id="{{stand.idStand}}" (click)="onStandClick(stand) " *ngFor="let stand of standsOut"
                            style="border: red solid;z-index: 999;
position: absolute;text-align: center;font-size: 11px;cursor: pointer; font-weight: bolder;text-transform: uppercase;"
                            [ngStyle]="{'width': stand.width*10+'px','height': stand.height*10+'px','top': stand.topL +'px'
,'left': stand.leftL+1500+'px'
    ,'border-top': '#000  solid 1px'
,'border-bottom':  '#000  solid '+stand.borederb+'px'
,'border-left':  '#000  solid '+stand.borederl +'px'
,'border-right':  '#000  solid '+stand.borederlr+'px'
,'background-color': stand.backgroundColor    }">
                                <div>
                                    <span *ngIf="stand.standType!='Flag' && stand.standType!='Entrance'"
                                        style="font-weight: bolder;">
                                        {{stand.num}}
                                    </span>
                                    <span style="color: red;font-size: 8px;"
                                        *ngIf="stand.standType!='Flag' && stand.standType!='Entrance'">
                                        {{stand.height*stand.width| number}}m2 </span>
                                    <img *ngIf="stand.standType=='Flag'"
                                        [ngStyle]="{'width': stand.width*10+'px','height': stand.height*10+'px'}"
                                        [src]="'../../../assets/img/'+stand.num+'.png'" />

                                    <img *ngIf="stand.standType=='Entrance'"
                                        [ngStyle]="{'width': stand.width*10+'px','height': stand.height*10+'px'}"
                                        [src]="'../../../assets/img/entrance.png'" />


                                    <img src="../../../assets/img/localise.gif"
                                        *ngIf="selectedList && selectedList.indexOf(stand.num) != -1" width="20"
                                        height="20">
                                    <img src="../../../assets/img/localise.gif" *ngIf="selectedStandId==stand.idStand"
                                        width="20" height="20">



                                </div>
                            </div>
                        </div>



                    </div>




                </div>
            </div>
            <p-overlayPanel *ngIf="selectedStand" #op>
                <span style="color: #05164D;">
                    {{selectedStand.num}}
                </span>

                {{selectedStand.remarque}}

            </p-overlayPanel>
            <!--
<script type="text/javascript">


function selectAnimd(id) {
 alert('sdfsdg');
   if (!click) {

       if (document.getElementById(id)) {
         $('html, body').animate({ 'zoom': 1.2 }, 400);
        /*   $('html, body').animate({
               scrollTop: $(document.getElementById(id)).offset().top - (windowHeight / 2), scrollLeft: $(document.getElementById(id)).offset().left - (windowWidth / 2)
           }, 900);
*/
       }
   }
}



 (function ($) {
     // Detect touch support
     $.support.touch = 'ontouchend' in document;
     // Ignore browsers without touch support
     if (!$.support.touch) {
     return;
     }
     var mouseProto = $.ui.mouse.prototype,
         _mouseInit = mouseProto._mouseInit,
         touchHandled;

     function simulateMouseEvent (event, simulatedType) { //use this function to simulate mouse event
     // Ignore multi-touch events
         if (event.originalEvent.touches.length > 1) {
         return;
         }
     event.preventDefault(); //use this to prevent scrolling during ui use

     var touch = event.originalEvent.changedTouches[0],
         simulatedEvent = document.createEvent('MouseEvents');
     // Initialize the simulated mouse event using the touch event's coordinates
     simulatedEvent.initMouseEvent(
         simulatedType,    // type
         true,             // bubbles                    
         true,             // cancelable                 
         window,           // view                       
         1,                // detail                     
         touch.screenX,    // screenX                    
         touch.screenY,    // screenY                    
         touch.clientX,    // clientX                    
         touch.clientY,    // clientY                    
         false,            // ctrlKey                    
         false,            // altKey                     
         false,            // shiftKey                   
         false,            // metaKey                    
         0,                // button                     
         null              // relatedTarget              
         );

     // Dispatch the simulated event to the target element
     event.target.dispatchEvent(simulatedEvent);
     }
     mouseProto._touchStart = function (event) {
     var self = this;
     // Ignore the event if another widget is already being handled
     if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
         return;
         }
     // Set the flag to prevent other widgets from inheriting the touch event
     touchHandled = true;
     // Track movement to determine if interaction was a click
     self._touchMoved = false;
     // Simulate the mouseover event
     simulateMouseEvent(event, 'mouseover');
     // Simulate the mousemove event
     simulateMouseEvent(event, 'mousemove');
     // Simulate the mousedown event
     simulateMouseEvent(event, 'mousedown');
     };

     mouseProto._touchMove = function (event) {
     // Ignore event if not handled
     if (!touchHandled) {
         return;
         }
     // Interaction was not a click
     this._touchMoved = true;
     // Simulate the mousemove event
     simulateMouseEvent(event, 'mousemove');
     };
     mouseProto._touchEnd = function (event) {
     // Ignore event if not handled
     if (!touchHandled) {
         return;
     }
     // Simulate the mouseup event
     simulateMouseEvent(event, 'mouseup');
     // Simulate the mouseout event
     simulateMouseEvent(event, 'mouseout');
     // If the touch interaction did not move, it should trigger a click
     if (!this._touchMoved) {
       // Simulate the click event
       simulateMouseEvent(event, 'click');
     }
     // Unset the flag to allow other widgets to inherit the touch event
     touchHandled = false;

     };
     mouseProto._mouseInit = function () {
     var self = this;
     // Delegate the touch handlers to the widget's element
     self.element
         .on('touchstart', $.proxy(self, '_touchStart'))
         .on('touchmove', $.proxy(self, '_touchMove'))
         .on('touchend', $.proxy(self, '_touchEnd'));

     // Call the original $.ui.mouse init method
     _mouseInit.call(self);
     };
 })(jQuery);


 </script>
-->


        </div>

    </mat-drawer-content>

</mat-drawer-container>